// // // // //------------stripe------------

// // // // // src/utils/config.js
// // // // // ─────────────────────────────────────────────
// // // // // Central configuration for the app
// // // // // Change price here — updates everywhere automatically
// // // // // ─────────────────────────────────────────────

// // // // const config = {
// // // //   // Payment amount in cents (e.g. 99 = $0.99, 199 = $1.99, 499 = $4.99)
// // // //   ANALYSIS_PRICE_CENTS: 199,

// // // //   // Display price shown to users
// // // //   ANALYSIS_PRICE_DISPLAY: "$1.99",

// // // //   // Product name shown on payment modal
// // // //   ANALYSIS_PRODUCT_NAME: "Resume ATS Analysis",

// // // //   // App name
// // // //   APP_NAME: "ResumeScoreAI",
// // // // };

// // // // export default config;

// // // // // // //------------------Paypal----------------------
// // // // // // // src/utils/config.js
// // // // // // const config = {
// // // // // //   // Payment amount (e.g. 1.99, 4.99, 9.99)
// // // // // //   ANALYSIS_PRICE_CENTS: 199,
// // // // // //   ANALYSIS_PRICE_DISPLAY: "$1.99",
// // // // // //   ANALYSIS_PRICE_VALUE: "1.99",     // PayPal uses decimal string

// // // // // //   ANALYSIS_PRODUCT_NAME: "Resume ATS Analysis",
// // // // // //   APP_NAME: "ResumeScoreAI",

// // // // // //   // ─────────────────────────────────────────
// // // // // //   // PayPal Client ID
// // // // // //   // Sandbox (testing): from developer.paypal.com
// // // // // //   // Live (production): switch to live credentials
// // // // // //   // ─────────────────────────────────────────
// // // // // //   PAYPAL_CLIENT_ID: "AaLc6jOpOlTvJ7LW0heJcboW0xrg-PpxS69ZpwNChC2DxX0b7z-a4Ir9IHWBb66FyULJBFqYhFlE4sN2",
// // // // // // };

// // // // // // export default config;

// // // src/utils/config.js
// // import servicesConfig from "./servicesConfig";

// // // Get the default pay per use plan
// // const defaultPlan = servicesConfig.plans.find(p => p.id === "pay_per_use");

// // const config = {
// //   // ── Dynamically read from servicesConfig ──
// //   ANALYSIS_PRICE_CENTS:   defaultPlan?.priceInCents || 199,
// //   ANALYSIS_PRICE_DISPLAY: defaultPlan?.price || "$1.99",
// //   ANALYSIS_PRICE_VALUE:   defaultPlan?.price?.replace("$", "") || "1.99",
// //   ANALYSIS_PLAN_ID:       defaultPlan?.id || "pay_per_use",
// //   ANALYSIS_PLAN_NAME:     defaultPlan?.name || "Pay Per Use",
// //   ANALYSIS_PRODUCT_NAME:  "ATS Resume Analysis",

// //   // ── App ──
// //   SUPPORT_EMAIL:  servicesConfig.app.email,
// //   DASHBOARD_URL:  "/dashboard",
// //   SUPPORT_URL:    "/support",
// // };

// // export default config;

// src/utils/config.js
import servicesConfig from "./servicesConfig";

// ── Get pay per use plan dynamically ──
const defaultPlan = servicesConfig.plans.find(p => p.id === "pay_per_use");

// ── Get ATS Analysis service dynamically ──
const atsService = servicesConfig.services.find(s => s.serviceCode === "ATS_ANALYSIS");

const config = {
  // ── Pricing — reads from servicesConfig ──
  ANALYSIS_PRICE_CENTS:   defaultPlan?.priceInCents  || 199,
  ANALYSIS_PRICE_DISPLAY: defaultPlan?.price         || "$1.99",
  ANALYSIS_PRICE_VALUE:   defaultPlan?.price?.replace("$", "") || "1.99",
  ANALYSIS_PLAN_ID:       defaultPlan?.id            || "pay_per_use",
  ANALYSIS_PLAN_NAME:     defaultPlan?.name          || "Pay Per Use",

  // ── Product ──
  ANALYSIS_PRODUCT_NAME:  atsService?.title          || "ATS Resume Analysis",
  ANALYSIS_SERVICE_CODE:  atsService?.serviceCode    || "ATS_ANALYSIS",

  // ── App ──
  APP_NAME:               servicesConfig.app.name    || "ResumeScoreAI",
  SUPPORT_EMAIL:          servicesConfig.app.email   || "support@smartaicareer.com",
  DASHBOARD_URL:          "/dashboard",
  SUPPORT_URL:            "/support",
};

export default config;